import { useCallback } from 'react';
import { Direction } from '../utils/spatialNavigation';

export default function useOnLeftArrowPress(callback) {
  return useCallback(
    (direction) => {
      if (direction === Direction.LEFT && callback) {
        callback();
        return false;
      }

      return true;
    },
    [callback],
  );
}
